import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import { map } from 'lodash';

import { FILTER_TIME_PERIODS } from '../../constants';
import messages from '../../messages';
import useFilterByTimePeriod from './useFilterByTimePeriod';

import './filterByTimePeriod.scss';

interface Props {}

const FilterByTimePeriod: React.FC<Props> = () => {
    const { currentPeriod, onChange } = useFilterByTimePeriod();

    return (
        <div styleName="container">
            {map(FILTER_TIME_PERIODS, period => (
                <div
                    key={period}
                    styleName={cn('item', {
                        'is-active': currentPeriod === period,
                    })}
                    onClick={() => onChange(period)}
                >
                    <FormattedMessage {...messages[period]} />
                </div>
            ))}
        </div>
    );
};

export default React.memo(FilterByTimePeriod);
